document.addEventListener('DOMContentLoaded', function() {
    const calculateButton = document.querySelector('.vpd-calculator-cannabis button');
    const temperatureInput = document.getElementById('temperature');
    const humidityInput = document.getElementById('humidity');
    const leafTemperatureInput = document.getElementById('leafTemperature');
    const vpdResultDiv = document.getElementById('vpdResult');

    calculateButton.addEventListener('click', function() {
        const temperature = parseFloat(temperatureInput.value);
        const humidity = parseFloat(humidityInput.value);
        const leafTemperature = parseFloat(leafTemperatureInput.value) || temperature;

        if (isNaN(temperature) || isNaN(humidity)) {
            vpdResultDiv.textContent = 'Bitte gib gültige Werte für Temperatur und Luftfeuchtigkeit ein.';
            return;
        }

        // Vereinfachte Näherung für den Sättigungsdampfdruck in kPa
        function saturatedVaporPressure(T) {
            const a = 0.61078; // Sättigungsdampfdruck bei 0°C in kPa
            const b = 17.08085;
            const c = 234.175;
            return a * Math.exp((b * T) / (T + c));
        }

        const satVPLeaf = saturatedVaporPressure(leafTemperature);
        const satVPAir = saturatedVaporPressure(temperature);
        const vpd = satVPLeaf - (satVPAir * (humidity / 100));

        vpdResultDiv.textContent = `VPD: ${vpd.toFixed(2)} kPa`;
    });
});